import { Paper, Text, Table } from '@mantine/core'

export function SkillGrowthTable({ skills }) {
  if (!skills?.length) return null

  return (
    <Paper p="md" className="glass">
      <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" fw={600} tt="uppercase" lts={1} mb="sm">
        Skill Growth Trajectory
      </Text>
      <Table
        horizontalSpacing="sm"
        verticalSpacing={6}
        styles={{
          th: { color: 'rgba(0, 229, 255, 0.6)', fontFamily: 'Orbitron, sans-serif', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase' },
          td: { fontSize: '0.8rem', fontFamily: 'Rajdhani, sans-serif' },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Skill</Table.Th>
            <Table.Th style={{ textAlign: 'center' }}>Demo</Table.Th>
            <Table.Th style={{ textAlign: 'center' }}>Wk 12</Table.Th>
            <Table.Th style={{ textAlign: 'center' }}>Wk 24</Table.Th>
            <Table.Th style={{ textAlign: 'center' }}>Growth</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {skills.map((s, i) => {
            const growth = s.demo != null ? s.week24 - s.demo : s.week24 - (s.week12 || 0)
            return (
              <Table.Tr key={i}>
                <Table.Td><Text size="sm" fw={600} c="gray.3">{s.name}</Text></Table.Td>
                <Table.Td style={{ textAlign: 'center' }}>
                  <Text size="sm" c="dimmed" fw={600}>{s.demo ?? '—'}</Text>
                </Table.Td>
                <Table.Td style={{ textAlign: 'center' }}>
                  <Text size="sm" c="gray.3" fw={600}>{s.week12}</Text>
                </Table.Td>
                <Table.Td style={{ textAlign: 'center' }}>
                  <Text size="sm" c="green.4" fw={700}>{s.week24}</Text>
                </Table.Td>
                <Table.Td style={{ textAlign: 'center' }}>
                  <Text size="sm" c="green.4" fw={700}>+{growth}</Text>
                </Table.Td>
              </Table.Tr>
            )
          })}
        </Table.Tbody>
      </Table>
    </Paper>
  )
}
